import { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import * as yup from 'yup';
import Grid from '@material-ui/core/Grid';
import ScaffoldAppScreen from '../../../containers/ScaffoldAppScreen';
import { TextInput } from '../../../controls/inputs';
import { AdviceDelivery, AdviceStatuses, AdviceType, OnboardDelivery, Product } from '../../../../api';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { clearClient, upsertClientAsync } from '../../../../store/adviser';
import { getAsync as getQuestionnaireAsync, upsertAsync as upsertQuestionnaireAsync } from '../../../../store/clientQuestionnaires';

const NewSatApplication = ({ history, match }: RouteComponentProps) => {
    const dispatch = useAppDispatch();
    const { upsertClientResult, isSubmitting: isSubmittingCreate } = useAppSelector(state => state.adviser);
    const { isLoading, isSubmitting } = useAppSelector(state => state.clientQuestionnaires);
    const productsCsv = (match.params as { products: string | undefined }).products?.split('-') || [];
    const products = [
        ...productsCsv.includes('ks') ? [Product.KiwiSaver] : [],
        ...productsCsv.includes('wb') ? [Product.WealthBuilder] : [],
        ...productsCsv.includes('ig') ? [Product.IncomeGenerator] : []
    ];

    useEffect(() => {
        if (upsertClientResult?.clientId) {
            (async () => {
                // Preload SAT
                await dispatch(upsertQuestionnaireAsync({ clientId: upsertClientResult.clientId, responses: { $$screensHistory$$: 'welcome, we-are-nz-funds' }}));
                await dispatch(getQuestionnaireAsync(upsertClientResult.clientId!));

                // Clear upserted client
                dispatch(clearClient());
                history.replace(`/adviser/sat/${upsertClientResult.clientId}`);
            })();
        }
    }, [upsertClientResult]);

    if (!products.length) history.replace('/adviser/new-application/select-products'); // fallback in case there are no products in the URL

    return <ScaffoldAppScreen
        hidePrev
        isNarrowView
        header="Savings Advice Tool"
        title="Let's get started."
        route="welcome"
        nextLabel="Start"
        disableNext={isSubmittingCreate || isSubmitting || isLoading}
        validationSchema={yup.object({
            firstName: yup.string().required('First name is required'),
            email: yup.string().email('Email is invalid').required('Email is required')
        })}
        initialValues={{
            firstName: '',
            email: '',
            products,
            kiwiSaverApplication: products.includes(Product.KiwiSaver) ? { active: true } : undefined,
            wealthBuilderApplications: products.includes(Product.WealthBuilder) ? [{ active: true }] : [],
            incomeGeneratorApplications: products.includes(Product.IncomeGenerator) ? [{ active: true }] : [],
            onboardDelivery: products.includes(Product.KiwiSaver) && products.length === 1 ? OnboardDelivery.BrowserKiwiSaverOnly : OnboardDelivery.Browser,
            adviceDelivery: AdviceDelivery.InPerson,
            adviceStatus: AdviceStatuses.None,
            adviceType: AdviceType.Limited,
            prepopulated: true
        }}
        onSubmit={values => dispatch(upsertClientAsync(values))}>
        <Grid container spacing={3} justifyContent="center">
            <Grid item sm={7} xs={12}>
                <TextInput label="Client first name" name="firstName" />
            </Grid>
            <Grid item sm={7} xs={12}>
                <TextInput label="Client email" name="email" type="email" />
            </Grid>
        </Grid>
    </ScaffoldAppScreen>
}

export default NewSatApplication;
